<template>
  <div class="collector-edit-page">
    <Button type="primary" icon="ios-arrow-back" @click="back">{{$t("device.collector.Return_to_collector_list")}}</Button>
    <Card class="edit-card">
        <div style="text-align:center">
          <h4>{{title}}</h4>
          <Form class="edit-form" :label-width="100" :model="formValidate" :rules="ruleValidate">
            <FormItem :label="$t('device.collector.deviceNo')" prop="deviceNo">
              <Input v-if="formValidate.id == 0" class="info" v-model="formValidate.deviceNo" :placeholder="$t('device.collector.please_enter')"></Input>
              <Input v-if="formValidate.id != 0 && check == true" class="info" v-model="formValidate.deviceNo" :placeholder="$t('device.collector.please_enter')"></Input>
              <Input v-if="formValidate.id != 0 && check == false" class="info" v-model="formValidate.deviceNo" :placeholder="$t('device.collector.please_enter')" disabled></Input>
            </FormItem>
            <FormItem :label="$t('device.collector.name')" prop="name">
              <Input class="info" v-model="formValidate.name" :placeholder="$t('device.collector.please_enter')"></Input>
            </FormItem>
            <FormItem :label="$t('device.collector.type')">
              <Input class="info" v-model="formValidate.type" :placeholder="$t('device.collector.please_enter')"></Input>
            </FormItem>
            <FormItem :label="$t('device.collector.routerID')" prop="routerID">
              <Select class="info" v-model="formValidate.routerID" :value="formValidate.routerID" @on-change="routerChange">
                <Option v-for="item in formValidate.routerList" :value="item.id" :key="item.id">{{ item.AnotherName }}</Option>
              </Select>
            </FormItem>
            <FormItem :label="$t('device.collector.computeType')" prop="computeType">
              <Select class="info" v-model="formValidate.computeType" :value="formValidate.computeType">
                <Option v-for="item in formValidate.computeTypes" :value="item.id" :key="item.id">{{ item.name }}</Option>
              </Select>
            </FormItem>
            <FormItem :label="$t('device.collector.length')" prop="length">
              <Input class="info" v-model="formValidate.length" :placeholder="$t('device.collector.please_enter_mm')"></Input>
            </FormItem>
            <FormItem :label="$t('device.collector.count')" prop="count">
              <Input class="info" v-model="formValidate.count" :placeholder="$t('device.collector.please_enter')"></Input>
            </FormItem>
            <FormItem :label="$t('device.collector.width')" prop="width">
              <Input class="info" v-model="formValidate.width" :placeholder="$t('device.collector.please_enter_mm')"></Input>
            </FormItem>
            <FormItem :label="$t('device.collector.deviceCompany')">
              <Input class="info" v-model="formValidate.deviceCompany" :placeholder="$t('device.collector.please_enter')"></Input>
            </FormItem>
            <FormItem :label="$t('device.collector.deviceModel')">
              <Input class="info" v-model="formValidate.deviceModel" :placeholder="$t('device.collector.please_enter')"></Input>
            </FormItem>
            <FormItem :label="$t('device.collector.buyTime')">
              <Input class="info" v-model="formValidate.buyTime" :placeholder="$t('device.collector.please_enter')"></Input>
            </FormItem>
            <FormItem :label="$t('device.collector.deviceLifeTime')">
              <Input class="info" v-model="formValidate.deviceLifeTime" :placeholder="$t('device.collector.please_enter')"></Input>
            </FormItem>
            <FormItem :label="$t('device.collector.remark')">
              <Input class="info" v-model="formValidate.remark" :placeholder="$t('device.collector.please_enter')"></Input>
            </FormItem>
            <hr>
            <div class="save-btn"><Button type="primary" @click="save()">{{$t("device.collector.save")}}</Button></div>
          </Form>
        </div>
    </Card>
  </div>
</template>
<script>
import {Api} from '@/api'
export default {
  name: 'RouterEdit',
  data () {
    return {
      formValidate: {
        id: 0,
        deviceNo: '',
        name: '',
        type: '',
        routerID: '',
        computeType: '',
        length: '',
        count: '',
        width: '',
        deviceCompany: '',
        deviceModel: '',
        buyTime: '',
        deviceLifeTime: '',
        mac: '',
        remark: '',
        routerList: [],
        computeTypes: []
      },
      ruleValidate: {
        name: [
            { required: true, message: this.$t('device.collector.Message.name'), trigger: 'blur' }
        ],
        deviceNo: [
            { required: true, message: this.$t('device.collector.Message.deviceNo'), trigger: 'blur' }
        ],
        computeType: [
            { required: true, message: this.$t('device.collector.Message.computeType'), pattern: /.+/, trigger: 'change' }
        ],
        routerID: [
            { required: true, message: this.$t('device.collector.Message.routerID'), pattern: /.+/, trigger: 'change' }
        ],
        length: [
            { required: true, message: this.$t('device.collector.Message.length'), trigger: 'blur' }
        ],
        count: [
            { required: true, message: this.$t('device.collector.Message.count'), trigger: 'blur' }
        ],
        width: [
            { required: true, message: this.$t('device.collector.Message.width'), trigger: 'blur' }
        ]
      },
      list: [],
      check: false
    }
  },
  computed: {
    title () {
      return this.id === 0 ? this.$t('device.collector.New_collector') : this.$t('device.collector.edit_collector')
    }
  },
  methods: {
    // handleSubmit (name) {
    //   this.$refs[name].validate((valid) => {
    //     if (valid) {
    //       this.$Message.success('Success!')
    //     } else {
    //       this.$Message.error('Fail!')
    //     }
    //   })
    // },
    // handleReset (name) {
    //   this.$refs[name].resetFields()
    // },
    back () {
      this.$router.back()
    },
    routerChange (id) {
      for (let i = 0; i < this.formValidate.routerList.length; i++) {
        if (id === this.formValidate.routerList[i].id) {
          this.mac = this.formValidate.routerList[i].mac
          break
        }
      }
    },
    save () {
      let collector
      if (Number(this.formValidate.length) % 1 !== 0 || Number(this.formValidate.count) % 1 !== 0 || Number(this.formValidate.width) % 1 !== 0) {
        const title = this.$t('device.collector.error')
        const content = '<p>' + this.$t('device.collector.length') + ',' + this.$t('device.collector.count') + ',' + this.$t('device.collector.width') + this.$t('device.collector.error_message2') + '</p>'
        this.$Modal.error({
          title: title,
          content: content
        })
      } else if (this.formValidate.deviceNo !== '' && this.formValidate.name !== '' && this.formValidate.routerID !== '' && this.formValidate.computeType !== '' && this.formValidate.length !== '' && this.formValidate.count !== '' && this.formValidate.width !== '') {
        collector = {
          id: this.formValidate.id,
          deviceNo: this.formValidate.deviceNo,
          name: this.formValidate.name,
          type: this.formValidate.type,
          routerID: this.formValidate.routerID,
          computeType: this.formValidate.computeType,
          length: Number(this.formValidate.length),
          count: Number(this.formValidate.count),
          width: Number(this.formValidate.width),
          deviceCompany: this.formValidate.deviceCompany,
          deviceModel: this.formValidate.deviceModel,
          buyTime: this.formValidate.buyTime,
          deviceLifeTime: this.formValidate.deviceLifeTime,
          mac: this.formValidate.mac,
          remark: this.formValidate.remark
        }
        Api.collector.save(collector).then(() => {
          this.$router.push({'name': 'Collector'})
        })
      } else {
        const title = this.$t('device.collector.error')
        const content = this.$t('device.collector.error_message1')
        this.$Modal.error({
          title: title,
          content: content
        })
      }
    }
  },
  mounted () {
    Api.router.list().then(res => {
      this.formValidate.routerList = res.routers
    })
    Api.computeType.list().then(res => {
      this.formValidate.computeTypes = res
      this.formValidate.computeTypes[0].name = this.$t('device.collector.roller')
      this.formValidate.computeTypes[1].name = this.$t('device.collector.weft_density')
      // console.log(this.formValidate.computeTypes)
    })
  },
  beforeRouteEnter (to, from, next) {
    let id = Number(to.params.id)
    // console.log(id)
    if (id !== 0) {
      Api.collector.get(id).then(res => {
        let c = res.collector
        next(vm => {
          Api.monitor.collectors().then(res => {
            vm.list = res.collectors
            vm.formValidate.id = c.id
            vm.formValidate.deviceNo = c.deviceNo
            vm.formValidate.name = c.name
            vm.formValidate.type = c.type
            vm.formValidate.routerID = c.routerID
            vm.formValidate.computeType = c.computeType
            vm.formValidate.length = c.length
            vm.formValidate.count = c.count
            vm.formValidate.width = c.width
            vm.formValidate.deviceCompany = c.deviceCompany
            vm.formValidate.deviceModel = c.deviceModel
            vm.formValidate.buyTime = c.buyTime
            vm.formValidate.deviceLifeTime = c.deviceLifeTime
            vm.formValidate.mac = c.mac
            vm.formValidate.remark = c.remark
            for (let i = 0; i < vm.list.length; i++) {
              if (vm.list[i].id === vm.formValidate.id && vm.list[i].status === '未知') {
                vm.check = true
              }
            }
          })
        })
      })
    } else {
      next()
    }
  }
}
</script>
<style scoped>
  .collector-edit-page {
    padding: 10px;
  }
  .edit-card {
    margin-top: 20px
  }
  .edit-form {
    padding: 20px 0px;
    text-align: left;
  }
  .edit-form .info {
    width: 33.33333%
  }
  hr {
    background-color: #dbdbdb;
    border: none;
    display: block;
    height: 1px;
    margin: 1.5rem 0;
  }
  .save-btn {
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// Edit.vue?1a36d40f